export const getPropertyOptions = (propertyDefinitionMap, propertyName) => propertyDefinitionMap[propertyName] && propertyDefinitionMap[propertyName].options;
export const getPropertyOptionsAsSelectOptions = (propertyDefinitionMap, propertyName) => {
  const propertyOptions = getPropertyOptions(propertyDefinitionMap, propertyName);
  let dropdownFooterOption = undefined;
  const selectOptions = propertyOptions.reduce((acc, option) => {
    const selectOption = {
      text: option.label,
      value: option.value
    };
    if (dropdownFooterOption === undefined && option.displayOrder < -1) {
      dropdownFooterOption = Object.assign({}, selectOption);
      return acc;
    }
    acc.push(selectOption);
    return acc;
  }, []);
  return {
    selectOptions,
    dropdownFooterOption
  };
};